import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer-top">
        <div className="footer-inner">
          <div className="footer-brand">
            <div className="footer-logo">
              <span className="logo-icon">✦</span>
              <span className="logo-text">Studi<span className="logo-gold">Line</span></span>
            </div>
            <p className="footer-tagline">
              Malaysia's trusted study consultancy. Helping ambitious students reach world-class universities across Malaysia and beyond.
            </p>
            <div className="footer-flags">🇲🇾 🇨🇦 🇬🇧 🇺🇸 🇦🇺 🇩🇪 🇮🇪 🇨🇾 🇲🇹 🇭🇺</div>
            <div className="footer-badges">
              <span className="footer-badge">✅ MOE Licensed</span>
              <span className="footer-badge">🏆 Award-Winning</span>
              <span className="footer-badge">🌍 52+ Universities</span>
            </div>
          </div>

          <div className="footer-col">
            <h4 className="footer-col-title">Quick Links</h4>
            <ul>
              <li><Link to="/">Home</Link></li>
              <li><Link to="/malaysian-universities">Malaysian Universities</Link></li>
              <li><Link to="/services">Our Services</Link></li>
              <li><Link to="/success-stories">Success Stories</Link></li>
              <li><Link to="/gallery">Gallery</Link></li>
              <li><Link to="/contact">Contact Us</Link></li>
            </ul>
          </div>

          <div className="footer-col">
            <h4 className="footer-col-title">Services</h4>
            <ul>
              <li><a href="#!">University Selection</a></li>
              <li><a href="#!">Application Help</a></li>
              <li><a href="#!">Visa Processing</a></li>
              <li><a href="#!">Scholarship Guidance</a></li>
              <li><a href="#!">Accommodation</a></li>
              <li><a href="#!">Pre-Departure Briefing</a></li>
            </ul>
          </div>

          <div className="footer-col">
            <h4 className="footer-col-title">Contact Us</h4>
            <ul>
              <li>
                <a href="mailto:studiline.bd@gmail.com">
                  📧 studiline.bd@gmail.com
                </a>
              </li>
              <li>
                <a href="https://wa.me/601169479883" target="_blank" rel="noopener noreferrer">
                  💬 WhatsApp: +60 1169479883
                </a>
              </li>
              <li><span style={{color:'var(--text-muted)'}}>📍 Kuala Lumpur, Malaysia</span></li>
              <li><span style={{color:'var(--text-muted)'}}>🕐 Mon–Sat, 9am–6pm MYT</span></li>
            </ul>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <div className="footer-inner footer-bottom-inner">
          <p>© 2024 StudiLine. All rights reserved.</p>
          
        </div>
      </div>
    </footer>
  );
}
